type FilledField = {
  id: string;
  value: unknown;
  created_at: string;
  updated_at: string;
  correction?: {
    status: string;
    comments?: Array<{
      text: string;
      creator?: { name: string; last_name: string };
    }>;
  } | null;
  [key: string]: unknown;
};

export function getLastFilledFieldWithCorrection(
  filledFields: FilledField[] | null | undefined,
): FilledField | undefined {
  if (!filledFields || filledFields.length === 0) return undefined;
  const lastWithCorrection = [...filledFields]
    .reverse()
    .find((ff) => ff.correction);
  return lastWithCorrection || filledFields.at(-1);
}

export const getLastFilledField = (
  filledFields: FilledField[] | null | undefined,
): FilledField | undefined => {
  if (!filledFields || filledFields.length === 0) return undefined;
  // same logic applied to get the cell value
  // backend send the filled fields ordered, so the last one is the most recent
  return [...filledFields].at(-1);
};
